export interface UpliftRule {
    uuid: string;
    headline: string;
    description?: string;
    value: number;
}

export interface UpliftRulesPage {
    rules: UpliftRule[];
    currentPage: number;
    totalPages: number;
    totalRules: number;
}

export interface UpliftRuleDto {
    uuid: string;
    headline: string;
    description?: string;
    value: number;
}

export function toUpliftRule(dto: UpliftRuleDto): UpliftRule {
    return { uuid: dto.uuid, headline: dto.headline, description: dto.description, value: dto.value };
}
